import React, {createContext} from "react";

const UserProfileContext = createContext({});

export default UserProfileContext;